<ng-container *ngIf="!accountLoading && (account$ | async) as account; else contentLoading">

  <div class="flex align-items-center mb-3">
    <span class="p-input-icon-left flex-grow-1 mr-3">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        (input)="charitiesTable.filterGlobal($any($event).target.value, 'contains')"
        placeholder="Search charity partners"
      />
    </span>
    <button
      pButton
      pRipple
      type="button"
      label="Add charity partner"
      icon="pi pi-plus"
      class="p-button-rounded flex-shrink-0"
      (click)="onAddCharity()"
    ></button>
  </div>

  <p-table
    #charitiesTable
    [value]="charitiesAsList(account.data?.content)"
    [globalFilterFields]="['name', 'slug']"
    styleClass="mt-3 p-datatable-striped"
    dataKey="_meta.id"
    responsiveLayout="scroll"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Slug</th>
        <th>Logo</th>
        <th>Published</th>
        <th style="width: 9rem"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-charity>
      <tr>
        <td><strong>{{ charity.name || '(unnamed)' }}</strong></td>
        <td><code *ngIf="charity.slug">{{ charity.slug }}</code><span *ngIf="!charity.slug" class="muted">—</span></td>
        <td>
          <i *ngIf="charity.logoFileId" class="pi pi-image text-500" title="Logo attached"></i>
          <span *ngIf="!charity.logoFileId" class="muted">—</span>
        </td>
        <td>
          <i *ngIf="charity.published !== false" class="pi pi-check app-text-ok" title="Published"></i>
          <i *ngIf="charity.published === false" class="pi pi-eye-slash text-500" title="Hidden"></i>
        </td>
        <td>
          <button
            pButton pRipple type="button" icon="pi pi-pencil"
            (click)="onEditCharity(charity)"
            class="p-button-rounded p-button-text" title="Edit"
          ></button>
          <!-- Scoped publish: ships THIS charity partner only. -->
          <button
            pButton pRipple type="button"
            [icon]="publishingSlug === charity.slug ? 'pi pi-spin pi-spinner' : 'pi pi-cloud-upload'"
            (click)="onPublishCharity(charity)"
            [disabled]="!charity.slug || !!publishingSlug"
            class="p-button-rounded p-button-text"
            [title]="!charity.slug ? 'Give the partner a slug first' : 'Publish just this charity partner to the staging preview'"
          ></button>
          <button
            pButton pRipple type="button" icon="pi pi-trash"
            (click)="onDeleteCharity(charity)"
            class="p-button-rounded p-button-danger p-button-text" title="Remove"
          ></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="p-text-center muted p-py-5">
          No charity partners yet. Use "Add charity partner" to create the first one.
        </td>
      </tr>
    </ng-template>
  </p-table>

</ng-container>

<!-- Shown while the account loads. Without it the modal opens onto an empty
     body for a second or two, which reads as broken rather than busy. -->
<ng-template #contentLoading>
  <div class="flex flex-column align-items-center justify-content-center p-6 text-500">
    <i class="pi pi-spin pi-spinner text-3xl mb-3" aria-hidden="true"></i>
    <span>Loading…</span>
  </div>
</ng-template>
